import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/ba-genie-app-main/ba-genie-app-main/components/home-boxes.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tabs","TabsList","TabsTrigger","TabsContent"] */ "/home/runner/work/ba-genie-app-main/ba-genie-app-main/components/ui/tabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tooltip","TooltipTrigger","TooltipContent"] */ "/home/runner/work/ba-genie-app-main/ba-genie-app-main/components/ui/tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/ba-genie-app-main/ba-genie-app-main/node_modules/next/dist/client/app-dir/link.js");
